import React from "reactn";
import BoxOrange from "../../../components/common/BoxOrange";
import BoxBlue from "../../../components/common/BoxBlue";

const count = value => Number(value) || 0;

class Leads extends React.PureComponent {
  render() {
    return (
      <div className="row">
        <div className="col-md-12">
          <div className="info-boxes">
            <div className="orange blue section">
              <BoxOrange
                boxName="Connections"
                boxCount={`${this.props.connectionsCount}`}
                boxNew={this.props.connectionsWeekCount}
                link="/partners/connections"
              />
              <BoxOrange
                boxName="Leads"
                boxCount={`${
                  count(this.props.formLeadsCount) +
                  count(this.props.appointmentsCount)
                }`}
                boxNew={
                  count(this.props.formLeadsWeekCount) +
                  count(this.props.appointmentsWeekCount)
                }
                link="/partners/form-leads"
              />
              <BoxOrange
                boxName="Applications"
                boxCount={`${this.props.applicationsCount}`}
                boxNew={this.props.applicationsWeekCount}
                link="/partners/applications"
              />
              <BoxBlue
                boxName="Total Listings"
                boxCount={`${this.props.listingsCount}`}
                boxNew={this.props.listingsWeekCount}
                link="/partners/programs/list"
              />
              <BoxBlue
                boxName="Enrollments"
                boxCount={`${this.props.enrollmentsCount}`}
                boxNew={this.props.enrollmentsWeekCount}
                link="/partners/active-leads"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Leads;
